import * as React from 'react';
import { useMemo } from 'react';

import { Avatar, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { type CourseSummaryTopPlayer } from '@api/courses-api.ts';
import { displayApiContent } from '@assets/helpers/utils/display-api-content.ts';

import { TEMP_IMAGE_SRC } from '../../assets/constants/index.tsx';
import { NAV_HELPERS, renderPrice } from '../../assets/helpers/utils/index.ts';
import { ArrowNextIcon } from '../../assets/icons/arrow-next.tsx';
import { LargePlayerIcon } from '../../assets/icons/large-player.tsx';
import { Card, Link } from '../../components/index.ts';

const playersInfo = [
  {
    id: 1,
    img: TEMP_IMAGE_SRC,
    name: 'Tiger Woods Jr.',
    phoneNumber: '+61 1300 139 399',
    betsCount: 72,
    priceAmount: 1540,
  },
  {
    id: 2,
    img: TEMP_IMAGE_SRC,
    name: 'Tiger Woods Jr.',
    phoneNumber: '+61 1300 139 399',
    betsCount: 72,
    priceAmount: 1540,
  },
  {
    id: 3,
    img: TEMP_IMAGE_SRC,
    name: 'Tiger Woods Jr.',
    phoneNumber: '+61 1300 139 399',
    betsCount: 72,
    priceAmount: 1540,
  },
  {
    id: 4,
    img: TEMP_IMAGE_SRC,
    name: 'Tiger Woods Jr.',
    phoneNumber: '+61 1300 139 399',
    betsCount: 72,
    priceAmount: 1540,
  },
  {
    id: 5,
    img: TEMP_IMAGE_SRC,
    name: 'Tiger Woods Jr.',
    phoneNumber: '+61 1300 139 399',
    betsCount: 72,
    priceAmount: 1540,
  },
];
playersInfo.length = 0;
type PT = {
  data?: CourseSummaryTopPlayer[];
};
export const TopPlayersCard = ({ data }: PT) => {
  const { palette, typography } = useTheme();

  const Body = useMemo(() => {
    if (!data || !data.length) {
      return (
        <Stack alignItems={'center'} height={'100%'}>
          <Stack
            alignItems={'center'}
            justifyContent={'center'}
            height={'100%'}
            sx={{ color: palette.light_dark }}
          >
            <LargePlayerIcon />
          </Stack>
          <Typography
            variant={'body_14_24'}
            color={palette.light_dark}
            sx={{ alignSelf: 'start', marginTop: 'auto' }}
          >
            No data available
          </Typography>
        </Stack>
      );
    }
    return (
      <Stack>
        {data?.map((el, i) => (
          <Link key={el.id} to={NAV_HELPERS.player(el.id)}>
            <Stack>
              <Stack direction={'row'} alignItems={'center'} gap={2}>
                <Box position={'relative'}>
                  <Avatar
                    variant={'circular'}
                    sx={{ zIndex: 0, width: 48, height: 48 }}
                    src={el.photo ?? undefined}
                    alt={el.photo ?? undefined}
                  />
                  <Stack
                    sx={{
                      zIndex: 2,
                      backgroundColor: 'white',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      border: `1px solid ${palette.dark}`,
                      color: palette.dark,
                      ...typography.small_description,
                    }}
                  >
                    {i + 1}
                  </Stack>
                </Box>
                <Stack flexGrow={1}>
                  <Typography noWrap variant={'body_14_24'} color={palette.dark}>
                    {displayApiContent(el.username)}
                  </Typography>
                  <Typography noWrap variant={'body_14_24'} color={palette.light_dark}>
                    {displayApiContent(el.phone)}
                  </Typography>
                </Stack>
                <Stack alignItems={'end'}>
                  <Typography noWrap variant={'body_14_24'} color={palette.dark}>
                    {renderPrice(el.revenue, { thousandsSeparator: ',' })}
                  </Typography>
                  <Typography noWrap variant={'body_14_24'} color={palette.light_dark}>
                    {el.games_count} bets
                  </Typography>
                </Stack>
              </Stack>
              {i < 4 && (
                <Box
                  sx={{
                    my: 5,
                    height: '1px',
                    background: palette.pale_accent,
                    width: '100%',
                  }}
                />
              )}
            </Stack>
          </Link>
        ))}
      </Stack>
    );
  }, [palette, typography, playersInfo, data]);

  return (
    <Card sx={{ width: 320, height: 504, borderRadius: 6, p: 6, gap: 6 }}>
      <Stack direction="row" alignItems={'center'} justifyContent={'space-between'}>
        <Typography variant={'title'} color={palette.semi_dark}>
          Top Players
        </Typography>
        <ArrowNextIcon style={{ color: palette.dark }} />
      </Stack>
      {Body}
    </Card>
  );
};
